module.exports = __webpack_public_path__ + "media/dashboard-empty-state.36a40692.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dashboard-empty-state.png
// module id = ./src/assets/dashboard-empty-state.png
// module chunks = 0